import { useState, useEffect } from 'react'

import XmlData42 from '../../assets/xml/TT-FIX42.xml'
import XmlData44 from '../../assets/xml/TT-FIX44.xml'


export function useTTFix(fixversion) {

  // Get Local XML data
  const [xmlString, setXmlString] = useState(false)
  const [finalFixObject, setFinalFixObject] = useState({})


  useEffect(() => {
    let _temp = {}

    if (fixversion && Object.keys(finalFixObject).length === 0) {

      fetch(fixversion === 44 ? XmlData44 : XmlData42)
        .then((r) => r.text())
        .then(text => {
          setXmlString(text)
        })

      if (xmlString) {

        const convert = require('xml-js')
        const options = { ignoreComment: true, alwaysChildren: true }
        const result = convert.xml2js(xmlString, options)
        const fields = result.elements[0].elements[4].elements // go to the fields element

        //console.log(fields)

        fields.forEach(field => {

          const name = field.attributes.name
          const number = field.attributes.number
          const elements = field.elements

          // Add Emums If Present
          let _enum = {}
          if (elements.length > 0) {
            elements.forEach(element => {
              _enum[element.attributes.enum] = element.attributes.description
            });
          }

          // Add Entry
          const _entry = {
            desc: name,
            enum: _enum
          }

          _temp[number.toString()] = _entry

        });

      }
      setFinalFixObject(_temp)
    }

  }, [finalFixObject, fixversion, xmlString])

  return finalFixObject

}
